export default __webpack_public_path__ + "static/media/rent_for_company_background.8f0ca28e.png";